<template>
    <div>
        <div style="width:100%; height: 34px; line-height: 30px;padding-left : 10px; font-size: 14px; background-color: #EFEFEF; ">
            查询字段
            <span v-if="!viewMode" class="ml10">
                <el-link type="danger" v-if="userMode == 0" class="ml20" style="padding-bottom:2px;font-size:13px;" size="mini" @click="clearQueryFields()">清除所有字段</el-link>
                <el-link type="primary" v-if="userMode == 0" class="ml20 mr20" style="padding-bottom:2px;font-size:13px;" size="mini" @click="addQueryField()">+ 追加字段</el-link>
                <el-divider v-if="userMode == 0" direction="vertical"></el-divider>
                <el-link v-if="userMode <2" type="primary" class="ml20" style="padding-bottom:2px;font-size:13px;" size="mini" title="把固定列按未来结果排在最前面" @click="bttopBasicFields()">基本项置于前</el-link>
            </span>
            <span v-if="userMode ==2 && !viewMode" class="fr mr5">
                <el-link type="primary" class="ml20" style="padding-bottom:2px;font-size:13px;" size="mini" title="把固定列按未来结果排在最前面" @click="bttopBasicFields()">基本项置于前</el-link>
                <span v-if="showExtBtns" class="fr ml30 mr5">
                    <label v-if="custSavable && onSaveCustConf != null" title="保存调整的同时带着当前查询条件值" style="font-size:12px;"><input type="checkbox" v-model="widthCurValues"/>带值</label>
                    <el-button v-if="custSavable && onSaveCustConf != null" @click="handleSaveCustConf()" size="mini" icon="el-icon-document-checked" style="margin-top: 1px;" title="保存个性调整">保存调整</el-button>
                    <el-divider v-if="custSavable && onSaveCustConf != null" direction="vertical"></el-divider>
                    <el-button @click="handleConfirm()" size="mini" icon="el-icon-check" style="margin-top: 1px;" title="应用调整">应用</el-button>
                    <a @click="handleClose()" title="取消/关闭" class="ml20 mr5" style="width:30px;height:30px;text-align: center;vertical-align: middle">
                        <i class="el-icon-close" style="font-size : 18px; "></i>
                    </a>
                </span>
            </span>
            <span class="fr mr5" v-if="userMode == 0 && !viewMode">
                <span>
                    <el-input size="mini" v-model="instantKeyword" class="mr10" placeholder="输入 过滤文本" style="width:100px;" clearable @change="filterList"></el-input>
                    <el-divider direction="vertical"></el-divider>
                    <span v-if="forHisQry">
                        <el-link type="primary" class="ml10 mr10" style="padding-bottom:2px;font-size:13px;" size="mini" icon="el-icon-notebook-2" @click="appendFromCols()">从表列选择</el-link>
                        <el-divider direction="vertical"></el-divider>
                    </span>
                </span>
                <span v-if="!uiUnion">
                    <el-link type="primary" class="ml10 mr10" style="padding-bottom:2px;font-size:13px;" size="mini" icon="el-icon-document" title="meta queryFields" @click="inputJsonConf()">输入json配置</el-link>
                </span>
            </span>
        </div>
        <!-- 字段扩展弹出框 -->
        <swb-dt-popover ref="fieldExtPopover" :disabled="userMode != 0" v-model="fieldExtEditorVisible" @show="syncFieldExtEditorVisible(true)" @hide="syncFieldExtEditorVisible(false)">
            <swb-prop-editor :title="fieldExtEditor.title" :showBtnBar="fieldExtEditor.showBtnBar" :width="fieldExtEditor.width" :widthForLabel="fieldExtEditor.widthForLabel" :propList="fieldExtEditor.propList" :extra="fieldExtEditor.extra"
                             :viewMode="fieldExtEditor.viewMode" :readOnly="fieldExtEditor.readOnly" :onConfirm="onFieldExtEditorConfirm" :onCancel="onFieldExtEditorCancel"></swb-prop-editor>
        </swb-dt-popover>
        <!-- 动态标签弹出框 -->
        <swb-dt-popover ref="dynaTagPopover" :disabled="userMode != 0" v-model="dynaTagEditorVisible" @show="syncDynaTagEditorVisible(true)" @hide="syncDynaTagEditorVisible(false)">
            <swb-prop-editor :title="dynaTagEditor.title" :showBtnBar="dynaTagEditor.showBtnBar" :width="dynaTagEditor.width" :widthForLabel="dynaTagEditor.widthForLabel" :propList="dynaTagEditor.propList" :extra="dynaTagEditor.extra"
                             :viewMode="dynaTagEditor.viewMode" :readOnly="dynaTagEditor.readOnly" :onConfirm="onDynaTagEditorConfirm" :onCancel="onDynaTagEditorCancel"></swb-prop-editor>
        </swb-dt-popover>
        <el-form name="gridTableWrapper" ref="gridForm" :model="gridForm" class="query-conf-form" style="transition: height 0.2s ease-in-out;">
            <el-table ref="gridTable" :data="gridForm.fieldConfRows" v-row-draggable="makeDragCtxData()" :row-class-name="getQueryRowClassName" :row-key="rowItemKey" :height="gridHeight" stripe highlight-current-row size="mini"
                      style="width: 100%;">
                <el-table-column label="序号" width="58" align="center" type="index" fixed></el-table-column>
                <el-table-column v-if="userMode == 0" label="代码" width="120" fixed>
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" :prop="'fieldConfRows[' + scope.$index + '].code'">
                            <el-input maxlength="30" class="field-code" v-model="scope.row.code" size="mini"/>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="标签" width="100" fixed>
                    <template slot-scope="scope">
                        <div class="text">
                            <el-form-item style="margin-bottom: 0" v-if="userMode == 0" :prop="'fieldConfRows[' + scope.$index + '].label'">
                                <el-input maxlength="20" class="field-label" v-model="scope.row.label" size="mini"/>
                            </el-form-item>
                            <div v-else="">{{ scope.row.label }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="输入类型" width="100" align="left" header-align="left">
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" v-if="userMode == 0" :prop="'fieldConfRows[' + scope.$index + '].type'">
                            <el-select class="field-type" v-model="scope.row.type" size="mini" @change="syncFieldValueInfo(scope.$index)">
                                <el-option v-for="fieldType in fieldTypes" :value="fieldType.value" :label="fieldType.label"></el-option>
                            </el-select>
                        </el-form-item>
                        <div v-else="">{{ getFieldTypeLabel(scope.row.type) }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="" width="16" align="center">
                    <template slot-scope="scope">
                        <label style="color:#3f8edf" title="占用单元空间数量">{{ getFieldTypeCellSpaces(scope.row.type) }}</label>
                    </template>
                </el-table-column>
                <el-table-column v-if="userMode == 0" label="数据类型" width="100" align="center" header-align="center">
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" :prop="'fieldConfRows[' + scope.$index + '].valueType'">
                            <select class="field-valueType" v-model="scope.row.valueType" @change="syncFieldTypeInfo(scope.$index)">
                                <option v-for="valueType in scope.row.validValueTypes" :value="valueType">{{ valueType }}</option>
                            </select>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column v-if="userMode == 0" label="数据来源" width="90" align="center">
                    <template slot-scope="scope">
                        <span>
                            <el-button v-if="scope.row.type == 'Select' || scope.row.type == 'RadioGroup'" size="mini" style="width:100%" @click="editFieldDataList(scope.$index)">数据列表</el-button>
                            <label v-if="(scope.row.type == 'Date' || scope.row.type == 'Date2') && scope.row.valueType != 'Integer'">
                                <input type="checkbox" v-model="scope.row.time"/>&nbsp;带有时间</label>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column v-if="userMode == 0" label="" width="64" align="center">
                    <template slot-scope="scope">
                        <label v-if="scope.row.type=='Select' || scope.row.type=='Casc'"><input type="checkbox" v-model="scope.row.multiple"/> 多选</label>
                    </template>
                </el-table-column>
                <el-table-column v-if="userMode == 0" label="默认值" width="120">
                    <template slot-scope="scope">
                        <el-form-item style="margin-bottom: 0" :prop="'fieldConfRows[' + scope.$index + '].value'">
                            <span>
                                <input type="text" style="width:80px;height:28px;padding-top:4px;font-size:12px;color:navy;" v-if="scope.row.type == 'Select' || scope.row.type == 'RadioGroup'" maxlength="30"
                                       @change="syncFieldTypeInfo(scope.$index)" v-model="scope.row.value"/>
                                <el-switch v-if="scope.row.type == 'Checkbox'" v-model="scope.row.value"></el-switch>
                            </span>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column v-if="userMode == 0" label="" width="22" align="center">
                    <template slot-scope="scope">
                        <el-link v-if="needFieldExtEditor(scope.row.type, scope.row.valueType)" @click="showFieldExtEditor($event, scope.$index)">
                            <i class="el-icon-more" title="设置特定扩展信息"></i>
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column label="基本项" width="60" align="center">
                    <template slot-scope="scope">
                        <input type="checkbox" :disabled="scope.row.hidden" v-model="scope.row.basic" @change="syncBasicField(scope.row, scope.$index)"/>
                    </template>
                </el-table-column>
                <el-table-column label="隐藏之" width="60" align="center">
                    <template slot-scope="scope">
                        <input type="checkbox" :disabled="userMode > 0 && scope.row.ctxBindName" v-model="scope.row.hidden" @change="syncHiddenField(scope.row, scope.$index)"/>
                    </template>
                </el-table-column>
                <el-table-column label="上下文属性" width="120" align="center" v-if="userMode == 0 && this.forHisQry">
                    <template slot-scope="scope">
                        <span v-if="scope.row.hidden">
                            <el-form-item style="margin-bottom: 0" :prop="'fieldConfRows[' + scope.$index + '].ctxBindName'">
                                <el-select class="field-type" v-model="scope.row.ctxBindName" size="mini" @change="syncFieldValueInfo(scope.$index)">
                                    <el-option v-for="ctxField in ctxFields" :value="ctxField.name" :label="ctxField.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="报表用" width="60" align="center" v-if="userMode == 0">
                    <template slot-scope="scope">
                        <input type="checkbox" v-model="scope.row.rptUsed"/>
                    </template>
                </el-table-column>
                <el-table-column label="动态标签" width="70" align="left" v-if="userMode == 0">
                    <template slot-scope="scope">
                        <div v-show="mayBeDynaTagField(scope.row.type, scope.row.valueType)">
                            <input type="checkbox" v-model="scope.row.dynaTag" @change="syncFieldValueInfo(scope.$index)"/>
                            <el-link v-show="scope.row.dynaTag" style="cursor: pointer;margin-left: 8px;" @click="showDynaTagEditor($event, scope.$index)">
                                <i class="el-icon-setting" title="设置动态标签字段配置信息"></i>
                            </el-link>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="!viewMode" label="操作/顺序" width="116" align="center" fixed="right">
                    <template slot-scope="scope">
                        <div>
                            <i class="icon iconfont icon-arrow-top pr10" style="cursor:pointer;" @click="moveQueryField(scope.$index, 'prev')"></i>
                            <i class="icon iconfont icon-arrow-bottom pr10" style="cursor:pointer;" @click="moveQueryField(scope.$index, 'next')"></i>
                            <i v-if="userMode == 0" class="icon iconfont el-icon-delete pl10 pr10" style="cursor:pointer;color:orange" @click="delQueryField(scope.$index)"></i>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
    </div>

</template>

<script>
    import {Utils, Jqext, $} from '../../app.base'
    import {
        Vue,
        MsgBox,
        VRowId,
        convertToTypedValue,
        getColDefAlign,
        getColDefFormat,
        calcDomHeight,
        getElTableHeight,
        fixElTableFixedHeight
    } from '../../app.vues'
    import {showDbColSelectDlg} from './dialog'
    import {openVarListDlg} from '../ctrl/dialog'
    import {evalDateExpr} from '../ctrl/Cmn';
    import SwbPropEditor from '../ctrl/PropEditor.vue';
    import SwbDtPopover from '../ctrl/DtPopover.vue';
    import SwbCodeEditor from '../ctrl/CodeEditor.vue'

    import {getSysCtxFields, makeTagMetaRoleList} from './Cmn'

    Vue.regist(SwbCodeEditor);

    let Toast = Jqext.Toast;

    function makeFieldTypes() {
        return [{
            label: '文本',
            value: 'Text',
            validValueTypes: ['String'],
            cellSpaces: 1
        }, {
            label: '日期',
            value: 'Date',
            validValueTypes: ['String', 'Date', 'Integer'],
            cellSpaces: 1
        }, {
            label: '日期范围',
            value: 'Date2',
            validValueTypes: ['String', 'Date', 'Integer'],
            cellSpaces: 2
        }, {
            label: '时间范围',
            value: 'Time2',
            validValueTypes: ['String', 'Date'],
            cellSpaces: 2
        }, {
            label: '下拉选择',
            value: 'Select',
            validValueTypes: ['Integer', 'String', 'Boolean'],
            cellSpaces: 1
        }, {
            label: '复选框',
            value: 'Checkbox',
            validValueTypes: ['Boolean'],
            cellSpaces: 1
        }, {
            label: '单选组',
            value: 'RadioGroup',
            validValueTypes: ['Integer', 'String', 'Boolean'],
            cellSpaces: 2
        }, {
            label: '数值',
            value: 'Num',
            validValueTypes: ['Integer', 'Float'],
            cellSpaces: 1
        }, {
            label: '数值范围',
            value: 'Num2',
            validValueTypes: ['Integer', 'Float'],
            cellSpaces: 2
        }, {
            label: '年月',
            value: 'Month',
            validValueTypes: ['Integer', 'String'],
            cellSpaces: 1
        }, {
            label: '年月范围',
            value: 'Month2',
            validValueTypes: ['Integer', 'String'],
            cellSpaces: 2
        }, {
            label: '弹出选择',
            value: 'Popup',
            validValueTypes: ['String', 'Integer'],
            cellSpaces: 1
        }, {
            label: '级联选择',
            value: 'Casc',
            validValueTypes: ['Integer', 'String'],
            cellSpaces: 1
        }];
    }

    //
    const _queryFieldTypeMap = makeFieldTypes().toMap('value');
    const _queryFieldCellSpacesMap = {};
    for (let type in _queryFieldTypeMap) {
        _queryFieldCellSpacesMap[type] = _queryFieldTypeMap[type].cellSpaces;
    }

    function getDefValueTypeFor(type) {
        let validValueTypes = _queryFieldTypeMap[type].validValueTypes;
        return validValueTypes[0];
    }

    function getFieldTypeCellSpaces(type) {
        return _queryFieldCellSpacesMap[type] || 0;
    }

    //console.debug(_queryFieldCellSpacesMap);

    //过滤基本查询字段（限制数量，如果超过返回 true）
    function filterBasicFieldCount(queyFieldList, limitCount) {
        if (limitCount <= 0) {
            return false;
        }
        let limitExceeded = false;
        //
        queyFieldList = queyFieldList || [];
        let foundCount = 0;
        let queryField = null;
        for (let i = 0, c = queyFieldList.length; i < c; i++) {
            queryField = queyFieldList[i];
            if (queryField.hidden) {//取消隐藏的基础字段
                queryField.basic = false;
            }
            if (queryField.basic) {
                foundCount += getFieldTypeCellSpaces(queryField.type);
                if (foundCount > limitCount) {
                    limitExceeded = true;
                    queryField.basic = false;
                }
            }
        }
        //
        return limitExceeded;
    }

    /** 按字符串判断是否成员之一 */
    function isStrMemberOf(chkVal, valList) {
        valList = valList || [];
        if (chkVal != null) {
            chkVal = chkVal + '';
        }
        for (let i = 0, c = valList.length; i < c; i++) {
            let tmpVal = valList[i];
            if (tmpVal != null) {
                tmpVal = tmpVal + '';
            }
            if (chkVal == tmpVal) {
                return true;
            }
        }
        return false;
    }

    //--------------------------------------------------
    function makePropListForQueryField(fieldInfo) {
        let propList = [];
        //
        let type = fieldInfo.type;
        if (type == 'Select') {
            propList.push({
                label: '清除后选中第一项',
                code: 'firstOnClear',
                inputType: 'Bool',
                valueType: 'Boolean',
                value: fieldInfo.firstOnClear == true
            });
            //
            if (fieldInfo.multiple) {
                propList.push({
                    label: '第一项与其他项互斥',
                    code: 'firstIsMutex',
                    inputType: 'Bool',
                    valueType: 'Boolean',
                    value: fieldInfo.firstIsMutex == true
                });
                //
                propList.push({
                    label: '限制多选择总条目数',
                    code: 'multipleLimit',
                    inputType: 'Num',
                    valueType: 'Integer',
                    value: fieldInfo.multipleLimit || 0,
                    tooltip: '0代表不限制'
                });
                //
                propList.push({
                    label: '多项显示为折叠标签',
                    code: 'collapseTags',
                    inputType: 'Bool',
                    valueType: 'Boolean',
                    value: fieldInfo.collapseTags != false
                });
            } else {
                propList.push({//多选时不支持，因为导致界面错乱
                    label: '支持输入过滤条目',
                    code: 'filterable',
                    inputType: 'Bool',
                    valueType: 'Boolean',
                    value: fieldInfo.filterable == true
                });
            }
        } else if (type == 'Date') {
            propList.push({
                label: '默认值表达式',
                code: 'defExpr',
                inputType: 'Single',
                valueType: 'String',
                asDropdown: true,
                value: fieldInfo.defExpr || '',
                dataList: [{
                    label: '- 无 -',
                    value: ''
                }, {
                    label: '--- 按日 ---',
                    value: '-',
                    disabled: true
                }, {
                    label: '当天',
                    value: 'today'
                }, {
                    label: '昨天',
                    value: 'today-1'
                }, {
                    label: '--- 按月 ---',
                    value: '-',
                    disabled: true
                }, {
                    label: '当月 第一天',
                    value: 'month.firstday'
                }, {
                    label: '当月 最后一天',
                    value: 'month.lastday'
                }, {
                    label: '上月 第一天',
                    value: 'month-1.firstday'
                }, {
                    label: '上月 最后一天',
                    value: 'month-1.lastday'
                }, {
                    label: '--- 按年 ---',
                    value: '-',
                    disabled: true
                }, {
                    label: '当年 第一天',
                    value: 'year.firstday'
                }, {
                    label: '当年 最后一天',
                    value: 'year.lastday'
                }, {
                    label: '去年 第一天',
                    value: 'year-1.firstday'
                }, {
                    label: '去年 最后一天',
                    value: 'year-1.lastday'
                }]
            });
        } else if (type == 'Date2') {
            propList.push({
                label: '默认起始值表达式',
                code: 'defExpr_from',
                inputType: 'Single',
                valueType: 'String',
                asDropdown: true,
                value: fieldInfo.defExpr_from || '',
                dataList: [{
                    label: '- 无 -',
                    value: ''
                }, {
                    label: '--- 按日 ---',
                    value: '-',
                    disabled: true
                }, {
                    label: '当天',
                    value: 'today'
                }, {
                    label: '昨天',
                    value: 'today-1'
                }, {
                    label: '--- 按月 ---',
                    value: '-',
                    disabled: true
                }, {
                    label: '当月 第一天',
                    value: 'month.firstday'
                }, {
                    label: '当月 最后一天',
                    value: 'month.lastday'
                }, {
                    label: '上月 第一天',
                    value: 'month-1.firstday'
                }, {
                    label: '上月 最后一天',
                    value: 'month-1.lastday'
                }, {
                    label: '--- 按年 ---',
                    value: '-',
                    disabled: true
                }, {
                    label: '当年 第一天',
                    value: 'year.firstday'
                }, {
                    label: '当年 最后一天',
                    value: 'year.lastday'
                }, {
                    label: '去年 第一天',
                    value: 'year-1.firstday'
                }, {
                    label: '去年 最后一天',
                    value: 'year-1.lastday'
                }]
            });
            propList.push({
                label: '默认终止值表达式',
                code: 'defExpr_to',
                inputType: 'Single',
                valueType: 'String',
                asDropdown: true,
                value: fieldInfo.defExpr_to || '',
                dataList: [{
                    label: '- 无 -',
                    value: ''
                }, {
                    label: '--- 按日 ---',
                    value: '-',
                    disabled: true
                }, {
                    label: '当天',
                    value: 'today'
                }, {
                    label: '昨天',
                    value: 'today-1'
                }, {
                    label: '--- 按月 ---',
                    value: '-',
                    disabled: true
                }, {
                    label: '当月 第一天',
                    value: 'month.firstday'
                }, {
                    label: '当月 最后一天',
                    value: 'month.lastday'
                }, {
                    label: '上月 第一天',
                    value: 'month-1.firstday'
                }, {
                    label: '上月 最后一天',
                    value: 'month-1.lastday'
                }, {
                    label: '--- 按年 ---',
                    value: '-',
                    disabled: true
                }, {
                    label: '当年 第一天',
                    value: 'year.firstday'
                }, {
                    label: '当年 最后一天',
                    value: 'year.lastday'
                }, {
                    label: '去年 第一天',
                    value: 'year-1.firstday'
                }, {
                    label: '去年 最后一天',
                    value: 'year-1.lastday'
                }]
            });
        } else if (type == 'Month') {
            propList.push({
                label: '默认值表达式',
                code: 'defExpr',
                inputType: 'Single',
                valueType: 'String',
                asDropdown: true,
                value: fieldInfo.defExpr || '',
                dataList: [{
                    label: '- 无 -',
                    value: ''
                }, {
                    label: '当月',
                    value: 'month.firstday'
                }, {
                    label: '上月',
                    value: 'month-1.firstday'
                }]
            });
        } else if (type == 'Month2') {
            propList.push({
                label: '默认起始值表达式',
                code: 'defExpr_from',
                inputType: 'Single',
                valueType: 'String',
                asDropdown: true,
                value: fieldInfo.defExpr_from || '',
                dataList: [{
                    label: '- 无 -',
                    value: ''
                }, {
                    label: '当月',
                    value: 'month.firstday'
                }, {
                    label: '上月',
                    value: 'month-1.firstday'
                }]
            });
            propList.push({
                label: '默认终止值表达式',
                code: 'defExpr_to',
                inputType: 'Single',
                valueType: 'String',
                asDropdown: true,
                value: fieldInfo.defExpr_to || '',
                dataList: [{
                    label: '- 无 -',
                    value: ''
                }, {
                    label: '当月',
                    value: 'month.firstday'
                }, {
                    label: '上月',
                    value: 'month-1.firstday'
                }]
            });
        } else if (type == 'Casc') {
            if (fieldInfo.multiple) {
                propList.push({
                    label: '多项显示为折叠标签',
                    code: 'collapseTags',
                    inputType: 'Bool',
                    valueType: 'Boolean',
                    value: fieldInfo.collapseTags != false
                });
            } else {
                propList.push({//多选时不支持，因为导致界面错乱
                    label: '支持输入过滤条目',
                    code: 'filterable',
                    inputType: 'Bool',
                    valueType: 'Boolean',
                    value: fieldInfo.filterable == true
                });
            }
        } else if (type == 'Text' && fieldInfo.valueType == 'String') {
            propList.push({
                label: '使用Like匹配',
                code: 'useLikeMatch',
                inputType: 'Bool',
                valueType: 'Boolean',
                value: fieldInfo.useLikeMatch == null ? true : fieldInfo.useLikeMatch || false
            });
        }
        return propList;
    }


    function makePropListForDynaTag(fieldInfo) {
        let propList = [];
        //
        if (fieldInfo.dynaTag == true) {
            propList.push({
                label: '参考位置',
                code: 'tagMetaRole',
                inputType: 'Single',
                valueType: 'Integer',
                asDropdown: true,
                dataList: makeTagMetaRoleList(),
                value: fieldInfo.tagMetaRole || null
            });
            propList.push({
                label: '参考表名',
                code: 'tagMetaTableName',
                inputType: 'Text',
                valueType: 'String',
                value: fieldInfo.tagMetaTableName || null
            });
        }

        return propList;
    }

    function isValidQueryField(queryField) {
        let valid = true;
        if (queryField == null) {
            valid = false;
        } else {
            if (queryField.code == null || queryField.code.trim() == '') {
                valid = false;
            } else if (queryField.label == null || queryField.label.trim() == '') {
                valid = false;
            } else if (queryField.type == null || queryField.type.trim() == '') {
                valid = false;
            }
            //
            if (queryField.type && !queryField.valueType) {
                queryField.valueType = getDefValueTypeFor(queryField.type);
            }
            //
            if (queryField.valueType == null || queryField.valueType.trim() == '') {
                valid = false;
            }
        }
        return valid;
    }

    export function extractCustQueryFieldInfo(queryField) {
        let custFieldInfo = null;
        if (queryField != null) {
            custFieldInfo = {
                code: queryField.code,
                //
                basic: queryField.basic || false,
                hidden: queryField.hidden || false,
                value: queryField.value
            };
            //
            if (typeof queryField.value != 'undefined') {
                custFieldInfo.value = queryField.value;
            }
            if (typeof queryField.text != 'undefined') {
                custFieldInfo.text = queryField.text || null;
            }
            return custFieldInfo;
        }
    }

    //处理日期类型的默认值表达式
    function hanleDefExprValues(queryField) {
        let type = queryField.type;
        if (type.isIn('Date', 'Month')) {
            let defExpr = queryField.defExpr || null;
            if (defExpr) {
                queryField.value = evalDateExpr(defExpr);
            }
        } else if (type.isIn('Date2', 'Month2')) {
            let defExprFlag = false;//是否有有效的表达式
            let defValue = {};
            let defExpr = queryField.defExpr_from || null;
            if (defExpr) {
                defExprFlag = true;
                defValue.from = evalDateExpr(defExpr);
            }
            defExpr = queryField.defExpr_to || null;
            if (defExpr) {
                defExprFlag = true;
                defValue.to = evalDateExpr(defExpr);
            }
            if (defExprFlag) {
                queryField.value = defValue;
            }
        }
    }

    //保留性地合并数组元素 arr1st <= arr2nd（保留arr1st中元素的属性值）
    export function reserveMergeQueryArray(arr1st, arr2nd, keyProp = 'id') {
        arr1st = arr1st || [];
        arr2nd = arr2nd || [];
        let arr2Map = arr2nd.toMap(keyProp);
        //去除不存在的
        for (let i = arr1st.length - 1; i >= 0; i--) {
            let item1st = arr1st[i] || {};
            let keyValue = item1st[keyProp];
            if (typeof arr2Map[keyValue] == 'undefined') {
                arr1st.removeAt(i);//已不存在删除之
                console.log('已去除不再有效的字段：' + keyProp + ' = ' + keyValue);
            }
        }
        let arrNew = [];
        for (let i = 0, c = arr1st.length; i < c; i++) {
            let item1st = extractCustQueryFieldInfo(arr1st[i]) || {};
            let keyValue = item1st[keyProp];
            let item2nd = Utils.merge({}, arr2Map[keyValue]);//copy
            delete arr2Map[keyValue]; //去掉
            arrNew[i] = Utils.merge(item2nd, item1st); // item2nd + item1st
            //
            hanleDefExprValues(arrNew[i]);
        }
        //加上剩余地
        for (let keyValue in arr2Map) {
            let tmpItem = arr2Map[keyValue];
            //
            hanleDefExprValues(tmpItem);
            arrNew.push(tmpItem);
        }
        //
        return arrNew;
    }

    //--------------------------------------------------
    const confHeaderHeight = 34;
    export default {
        components: {SwbPropEditor, SwbDtPopover},
        name: 'swb-query-field-conf',
        desc: '查询字段信息配置',
        //
        props: {
            //是否查看模式
            viewMode: {
                type: Boolean,
                default: false
            },
            userMode: {//用户模式：0: 开发模式, 1: 运营模式，2：用户模式
                type: Number,
                default: 2
            },
            givenCtxBindings: {//给定 colName => ctxBindName
                type: Object,
                default: null
            },
            //是否为历史查询
            forHisQry: {
                type: Boolean,
                default: false
            },
            //历史表名（仅供历史查询设计用）
            hisTblName: {
                type: String,
                default: null
            },
            showExtBtns: {//是否显示扩展按钮
                type: Boolean,
                default: false
            },
            uiUnion: {//是否与SortFieldConf联合ui模式
                type: Boolean,
                default: false
            },
            custSavable: {//自定义信息是否可以保存
                type: Boolean,
                default: false
            },
            onSaveCustConf: {//保存自定义调整处理函数
                type: Function,
                default: null
            },
            onConfirm: {//应用按钮处理函数
                type: Function,
                default: null
            },
            onClose: {//关闭按钮处理函数
                type: Function,
                default: null
            },
            metaQueryFields: {
                type: Array,
                default: null
            },
            custQueryFields: {//code => basic, hidden [, value, text ]
                type: Array,
                default: null
            },
            basicMaxSpaces: {//基本区域最大单元数量( <=0 : 不限制）
                type: Number,
                default: -1
            },
            height: {//指定的高度
                default: 0
            }
        },
        //
        data() {
            return {
                theVRowId: null,
                rowItemKey: 'code',
                //
                instantKeyword: '', //及时关键字
                delayedKeyword: '', //延迟关键字
                //最大的高度
                maxHeight: 0,
                //
                gridHeight: '100%',
                //
                tooltipDelayMs: 1000,
                //
                fieldTypes: makeFieldTypes(),
                fieldTypeMap: {},
                //
                ctxFields: [],
                ctxFieldMap: {},
                //
                metaQueryFieldsInner: [],
                custQueryFieldsInner: [],
                //
                widthCurValues: false,
                //
                gridForm: {
                    fieldConfRows: []
                },
                //
                fieldExtEditorVisible: false,
                fieldExtEditor: {
                    width: 400,
                    widthForLabel: 180,
                    showBtnBar: true,
                    viewMode: false,
                    readOnly: false,
                    //
                    name: null,
                    title: '查询字段扩展信息',
                    propList: [],
                    extra: null
                },
                //
                dynaTagEditorVisible: false,
                dynaTagEditor: {
                    width: 400,
                    widthForLabel: 120,
                    showBtnBar: true,
                    viewMode: false,
                    readOnly: false,
                    //
                    name: null,
                    title: '动态标签配置信息',
                    propList: [],
                    extra: null
                }
            };
        },
        watch: {
            userMode(newVal, oldVal) {
                this.rowItemKey = this.userMode == 0 ? this.theVRowId.name() : 'code';
                //
                this.init();
            },
            givenCtxBindings(newVal, oldVal) {
                this.init();
            },
            forHisQry(newVal, oldVal) {
                this.init();
            },
            metaQueryFields(newVal, oldVal) {
                this.metaQueryFieldsInner = Utils.merge([], this.metaQueryFields);
                this.custQueryFieldsInner = [];
                //
                this.init();
            },
            custQueryFields(newVal, oldVal) {
                this.custQueryFieldsInner = Utils.merge([], this.custQueryFields);
                //
                this.init();
            },
            height(newVal, oldVal) {
                this.setHeights();
            }
        },
        //
        created() {
            this.theVRowId = VRowId.newOne().name('_row_id_');
            //
            this.fieldTypeMap = this.fieldTypes.toMap('value');
            //
            let ctxFields = getSysCtxFields();
            ctxFields.unshift({
                name: null,
                value: '- 无 -'
            })
            this.ctxFields = ctxFields;
            let ctxFieldMap = {};
            ctxFields.forEach(function (ctxField) {
                ctxFieldMap[ctxField.name] = ctxField.value;
            });
            this.ctxFieldMap = ctxFieldMap;
            //
            this.rowItemKey = this.userMode == 0 ? this.theVRowId.name() : 'code';
            //
            this.metaQueryFieldsInner = Utils.merge([], this.metaQueryFields);
            this.custQueryFieldsInner = Utils.merge([], this.custQueryFields);
        },
        //
        mounted() {
            let thisEl = $(this.$el);
            //
            this.gridTableWrapper = thisEl.find('>[name="gridTableWrapper"]');
            this.gridTable = this.$refs['gridTable'];
            //
            this.init();
            //
            this.setHeights();
        },
        beforeDestroy() {
            //ctrl
            this.gridTableWrapper = null;
            this.gridTable = null;
            //data
            this.fieldExtEditor = null;
            this.dynaTagEditor = null;
            this.gridForm = null;
            this.metaQueryFieldsInner = null;
            this.custQueryFieldsInner = null;
            this.fieldTypes = null;
            this.fieldTypeMap = null;
        },
        destroyed() {
            this.theVRowId = null;
        },
        //
        methods: {
            //返回推拽信息（注意绑定表达式写法：v-row-draggable="makeDragCtxData()"）
            makeDragCtxData() {
                return {
                    //函数调用上下文
                    context: this,
                    //数据提供者（基于 context 调用，可以使用 this）
                    provider: function () {
                        //返回 null 或 false 代表不允许拖拽
                        return this.gridForm.fieldConfRows || [];
                    },
                    //数据变更回调函数（基于 context 调用，可以使用 this）
                    callback: function (dataList, newIndex) {
                        //console.log(dataList);
                        //console.log('条目已经移动到第 ' + (newIndex + 1) + ' 行');
                        this.$set(this.gridForm, 'fieldConfRows', dataList);
                        //
                        this.$nextTick(function () {
                            this.gridTable.setCurrentRow(dataList[newIndex]);
                        });
                    }
                };
            },
            setHeights() {
                let gridHeight = this.gridHeight = this.getGridHeight();
                this.gridTableWrapper.height(gridHeight);
                //
                this.gridTable.doLayout();
            },
            setMaxHeight(maxHeight) {
                this.maxHeight = maxHeight || 0;
                //
                this.setHeights();
            },
            getGridHeight() {
                let extraHeight = confHeaderHeight; //头部固定高度
                let gridTable = this.gridTable;
                return this.calcGridHeight(gridTable, this.height, this.maxHeight, extraHeight);
            },
            calcGridHeight(gridTable, height, maxHeight, extraHeight = 0) {
                height = height || 0;
                let heightGiven = typeof height == 'number' && height > 0;
                if (heightGiven) {
                    height = Math.max(height, extraHeight);
                }
                maxHeight = maxHeight || 0;
                let gridHeight = height || '100%';
                let needHeight = getElTableHeight(gridTable);
                if (maxHeight > 0) {//限定最大高度
                    maxHeight = Math.max(maxHeight, extraHeight);
                    if (needHeight + extraHeight > maxHeight) {//不超过最大高度
                        gridHeight = maxHeight - extraHeight;
                    } else {
                        let adjusted = false;
                        if (heightGiven) {//同时指定了高度
                            height = Math.min(height, maxHeight);
                            if (needHeight + extraHeight < height) {//不低于指定高度
                                gridHeight = height - extraHeight;
                                adjusted = true;
                            }
                        }
                        if (!adjusted) {//未指定高度，自动伸缩
                            gridHeight = needHeight;
                        }
                    }
                } else {//仅指定了高度
                    if (heightGiven) {
                        gridHeight = height - extraHeight;
                    }
                }
                return gridHeight;
            },
            getQueryRowClassName({row, rowIndex}) {
                let classNames = [];
                //
                if (this.userMode == 0) {//增加过滤隐藏class
                    let keyword = (this.delayedKeyword || '').trim();
                    if (keyword.length > 0) {
                        //忽略大小写匹配
                        keyword = keyword.toLowerCase();

                        let filterOk = false;
                        let tempStr = row.label || '';
                        if (tempStr.toLowerCase().indexOf(keyword) != -1) {
                            filterOk = true;
                        }

                        if (!filterOk) {
                            tempStr = row.code || '';
                            if (tempStr.toLowerCase().indexOf(keyword) != -1) {
                                filterOk = true;
                            }
                        }
                        //
                        if (!filterOk) {
                            classNames.push('filter-hidden');
                        }
                    }
                }

                if (row.basic) {
                    classNames.push('basic-field');
                }
                if (row.hidden) {
                    classNames.push('hidden-field');
                }
                //
                if (row.code == null || row.code.trim() == '') {
                    classNames.push('invalid-code');
                }
                if (row.label == null || row.label.trim() == '') {
                    classNames.push('invalid-label');
                }
                if (row.type == null || row.type.trim() == '') {
                    classNames.push('invalid-type');
                }
                if (row.valueType == null || row.valueType.trim() == '') {
                    classNames.push('invalid-valueType');
                }
                //
                return classNames.join(' ');
            },
            getFieldTypeLabel(type) {
                let fieldType = this.fieldTypeMap[type];
                return fieldType == null ? null : fieldType.label;
            },
            getFieldTypeCellSpaces(type) {
                return getFieldTypeCellSpaces(type);
            },
            init(metaQueryFields) {
                if (metaQueryFields != null) {//完全重新替换
                    this.metaQueryFieldsInner = Utils.merge([], metaQueryFields);
                    this.custQueryFieldsInner = [];//清空
                } else if (this.userMode < 2) {//非用户模式忽略自定义
                    this.custQueryFieldsInner = [];
                }
                let fieldConfRows = this.userMode == 2 ? reserveMergeQueryArray(this.custQueryFieldsInner, this.metaQueryFieldsInner, 'code') : this.metaQueryFieldsInner;
                //
                if (this.rowItemKey == this.theVRowId.name()) {
                    this.theVRowId.setIds(fieldConfRows);
                } else {
                    this.theVRowId.delIds(fieldConfRows);
                }
                //基本过滤
                fieldConfRows.forEach(function (queryField) {
                    if (queryField.ctxBindName) {//强制绑定上下文隐藏
                        queryField.hidden = true;
                    }
                });
                //console.debug(fieldConfRows);
                filterBasicFieldCount(fieldConfRows, this.basicMaxSpaces);
                //
                this.gridForm.fieldConfRows = fieldConfRows;
                //
                if (this.userMode == 0) {
                    this.$nextTick(function () {
                        for (let i = 0, c = this.gridForm.fieldConfRows.length; i < c; i++) {
                            this.syncFieldValueInfo(i);
                        }
                    });
                }
                //
                let self = this;
                setTimeout(function () {
                    if (self.gridTable != null) {
                        self.gridTable.doLayout();
                    }
                }, 500);
            },
            syncFieldValueInfo(index) {
                let fieldConfRows = this.gridForm.fieldConfRows;
                let fieldInfo = fieldConfRows[index];
                //
                let fieldType = this.fieldTypeMap[fieldInfo.type];
                if (fieldType == null) {
                    return;
                }
                //dataList
                if (fieldType.value.isIn('Select', 'RadioGroup')) {
                    if (fieldInfo.dataList == null) {
                        fieldInfo.dataList = [];
                    }
                }
                //动态标签字段
                if (!fieldInfo.dynaTag) {
                    delete fieldInfo['tagMetaRole'];
                    delete fieldInfo['tagMetaTableName'];
                }
                //
                let valueType = fieldInfo.valueType;
                //
                let validValueTypes = fieldType.validValueTypes;
                fieldInfo.validValueTypes = validValueTypes;
                if (validValueTypes.indexOf(valueType) == -1) {
                    valueType = validValueTypes[0];
                }
                fieldInfo.valueType = valueType;
                fieldInfo.ctxBindName = fieldInfo.ctxBindName || null;
                this.$set(fieldConfRows, index, fieldInfo);
            },
            syncFieldTypeInfo(index, action) {
                let fieldConfRows = this.gridForm.fieldConfRows;
                let fieldInfo = fieldConfRows[index];
                //
                let fieldType = fieldInfo.type;
                let valueType = fieldInfo.valueType;
                if (fieldType == null || valueType == null) {
                    delete fieldInfo.value;
                } else if (fieldType.isIn('Select', 'RadioGroup', 'Checkbox')) {
                    fieldInfo.value = convertToTypedValue(fieldInfo.value, valueType);
                } else {
                    delete fieldInfo.value;
                }
                this.$set(fieldConfRows, index, fieldInfo);
            },
            editFieldDataList(index) {
                let fieldConfRows = this.gridForm.fieldConfRows;
                let fieldInfo = fieldConfRows[index];
                let dataList = fieldInfo.dataList || [];
                let dataLabel = fieldInfo.dataLabel || 'label';
                let dataValue = fieldInfo.dataValue || 'value';
                let valueType = fieldInfo.valueType;

                //
                let self = this;

                let dlgConfig = {
                    dlgTitle: '设置数据列表',
                    initHint: '双击某一条，即可设置默认值',
                    editable: true,
                    fixedType: valueType,
                    selectable: true,
                    dblClickHandler: function (selected) {
                        fieldInfo.value = selected.value;
                        self.$set(fieldConfRows, index, fieldInfo);
                        Toast.show('【' + fieldInfo.label + '】 的默认值已设置');
                    },
                    varList: dataList.map(function (item) {
                        return {
                            name: item[dataLabel],
                            type: valueType,
                            value: item[dataValue]
                        };
                    })
                };
                //
                openVarListDlg(dlgConfig, function (valueList, theDlg) {
                    //console.log(valueList);
                    //
                    fieldInfo.dataList = valueList.map(function (item) {
                        let datum = {};
                        datum[dataLabel] = item.name;
                        datum[dataValue] = item.value;
                        return datum;
                    });
                    self.$set(fieldConfRows, index, fieldInfo);
                    //
                    theDlg.hide();
                });
            },
            syncFieldExtEditorVisible(visible) {
                this.fieldExtEditorVisible = visible;
            },
            needFieldExtEditor(type, valueType) {
                let needed = type != null && type.isIn('Select', 'Date', 'Date2', 'Month', 'Month2', 'Casc');
                if (!needed) {
                    needed = type == 'Text' && valueType == 'String';
                }
                return needed;
            },
            showFieldExtEditor(event, index) {
                let targetBtn = event.currentTarget;
                //
                let fieldConfRows = this.gridForm.fieldConfRows;
                let fieldInfo = fieldConfRows[index];
                // console.debug(fieldInfo);
                let propList = makePropListForQueryField(fieldInfo);
                //
                let fieldExtEditor = this.fieldExtEditor;
                this.$set(fieldExtEditor, 'name', fieldInfo.code);
                this.$set(fieldExtEditor, 'title', '【' + (fieldInfo.label || fieldInfo.code) + '】扩展信息');
                this.$set(fieldExtEditor, 'propList', propList);
                this.$set(fieldExtEditor, 'extra', index);
                //
                let fieldExtPopover = this.$refs['fieldExtPopover'];
                fieldExtPopover.bindToReferer(targetBtn, 'click', {
                    showNow: true,
                    placement: 'left-start'
                });
            },
            onFieldExtEditorConfirm(name, propValues, extra, editor) {
                let index = extra;
                //console.debug(index);
                //console.debug(propValues);
                this.fieldExtEditorVisible = false;
                //
                let fieldConfRows = this.gridForm.fieldConfRows;
                let fieldInfo = fieldConfRows[index];
                Utils.merge(fieldInfo, propValues);
                this.$set(fieldConfRows, index, fieldInfo);
            },
            onFieldExtEditorCancel(name, extra, editor) {
                let index = extra;
                //console.debug(index);
                this.fieldExtEditorVisible = false;
            },
            //
            syncDynaTagEditorVisible(visible) {
                this.dynaTagEditorVisible = visible;
            },
            //只有Select && Integer的才能作为动态标签列
            mayBeDynaTagField(type, valueType) {
                return type == 'Select' && valueType == 'Integer';
            },
            showDynaTagEditor(event, index) {
                let targetBtn = event.currentTarget;
                //
                let fieldConfRows = this.gridForm.fieldConfRows;
                let fieldInfo = fieldConfRows[index];
                console.debug(fieldInfo);

                let propList = makePropListForDynaTag(fieldInfo);
                //
                let dynaTagEditor = this.dynaTagEditor;
                this.$set(dynaTagEditor, 'name', fieldInfo.code);
                this.$set(dynaTagEditor, 'title', '【' + (fieldInfo.label || fieldInfo.code) + '】标签配置');
                this.$set(dynaTagEditor, 'propList', propList);
                this.$set(dynaTagEditor, 'extra', index);
                //
                let dynaTagPopover = this.$refs['dynaTagPopover'];
                dynaTagPopover.bindToReferer(targetBtn, 'click', {
                    showNow: true,
                    placement: 'left-start'
                });
            },
            onDynaTagEditorConfirm(name, propValues, extra, editor) {
                let index = extra;
                //console.debug(index);
                //console.debug(propValues);
                this.dynaTagEditorVisible = false;
                //
                let fieldConfRows = this.gridForm.fieldConfRows;
                let fieldInfo = fieldConfRows[index];
                Utils.merge(fieldInfo, propValues);
                this.$set(fieldConfRows, index, fieldInfo);
            },
            onDynaTagEditorCancel(name, extra, editor) {
                let index = extra;
                //console.debug(index);
                this.dynaTagEditorVisible = false;
            },
            bttopBasicFields() {
                let fieldConfRows = this.gridForm.fieldConfRows;
                this.gridForm.fieldConfRows = fieldConfRows.split(function (item) {
                    return item.basic == true ? 0 : 1;
                }, true).flatten();
            },
            syncBasicField(queryField, theIndex) {
                let basic = queryField.basic || false;
                if (basic) {
                    let limitExceeded = filterBasicFieldCount(this.gridForm.fieldConfRows, this.basicMaxSpaces);
                    if (limitExceeded) {
                        this.gridForm.fieldConfRows = this.gridForm.fieldConfRows.clone();
                        //
                        this.$message({
                            message: '基本字段最多只能占 ' + this.basicMaxSpaces + ' 个单元空间',
                            type: 'warning'
                        });
                    } else {
                        this.$set(this.gridForm.fieldConfRows, theIndex, Utils.merge(queryField));
                    }
                }
            },
            syncHiddenField(queryField, theIndex) {
                if (queryField.hidden) {
                    //取消隐藏的基础字段性质
                    queryField.basic = false;
                    ////自动初始化
                    if (this.userMode == 0) {
                        //自动初始化上下文绑定
                        if (queryField.ctxBindName == null && this.forHisQry && this.givenCtxBindings != null) {
                            queryField.ctxBindName = this.givenCtxBindings[queryField.code] || null;
                        }
                    }
                } else {
                    if (this.userMode == 0) {
                        queryField.ctxBindName = null;
                    }
                }
                this.$set(this.gridForm.fieldConfRows, theIndex, Utils.merge(queryField));
            },
            clearQueryFields() {
                if (this.userMode > 0) {
                    return;
                }
                //
                this.init([]);
            },
            addQueryField() {
                if (this.userMode > 0) {
                    return;
                }
                //
                let fieldConfRows = this.gridForm.fieldConfRows;
                let queryField = {
                    code: '',
                    label: '',
                    type: 'Text',
                    valueType: '',
                    value: null,
                    basic: false,
                    hidden: false,
                    rptUsed: false,
                    useLikeMatch: true,
                    ctxBindName: null
                };
                //自动初始化上下文绑定
                if (queryField.ctxBindName == null && this.forHisQry && this.givenCtxBindings != null) {
                    queryField.ctxBindName = this.givenCtxBindings[queryField.code] || null;
                }
                //
                this.theVRowId.setId(queryField);
                //
                fieldConfRows.append(queryField);
                //
                this.init(fieldConfRows);
            },
            delQueryField(index) {
                if (this.userMode > 0) {
                    return;
                }
                //
                let fieldConfRows = this.gridForm.fieldConfRows.clone();
                fieldConfRows.removeAt(index);
                this.gridForm.fieldConfRows = fieldConfRows;
            },
            moveQueryField(index, where) {
                let fieldConfRows = this.gridForm.fieldConfRows.clone();
                fieldConfRows.move([index], where);
                this.gridForm.fieldConfRows = fieldConfRows;
            },
            filterList() {
                //利用change事件避免频繁模型的值频繁触发事件
                this.delayedKeyword = this.instantKeyword;
            },
            appendByCols(selCols) {
                if (this.userMode > 0) {
                    return;
                }
                //
                selCols = selCols || [];
                if (selCols.length > 0) {
                    let fieldConfRows = this.gridForm.fieldConfRows;
                    for (let i = 0, c = selCols.length; i < c; i++) {
                        let tmpCol = selCols[i];
                        let queryField = {
                            code: tmpCol.columnName,
                            label: tmpCol.comment,
                            value: null,
                            basic: false,
                            hidden: false,
                            rptUsed: false,
                            ctxBindName: null,
                            //
                            type: 'Text',
                            valueType: '',
                            useLikeMatch: true
                        };
                        let javaType = tmpCol.javaType;
                        if (javaType == 'java.sql.Time') {
                            queryField.type = 'Time2'
                            queryField.valueType = 'Date';
                        } else if (javaType == 'java.sql.Timestamp') {
                            queryField.type = 'Date2'
                            queryField.valueType = 'Date';
                            queryField.time = true
                        } else if (javaType == 'java.sql.Date' || javaType == 'java.util.Date') {
                            queryField.type = 'Date2'
                            queryField.valueType = 'Date';
                        } else {
                            //转为简单名称
                            let dotIndex = javaType.lastIndexOf('.');
                            javaType = dotIndex == -1 ? javaType : javaType.substring(dotIndex + 1);
                            if (javaType.isIn('Long', 'Short', 'Byte')) {
                                javaType = 'Integer';
                            } else if (javaType.isIn('Double', 'BigDecimal')) {
                                javaType = 'Float';
                            }
                            queryField.valueType = javaType;
                            if (javaType == 'Boolean') {
                                queryField.type = 'Checkbox';
                            } else if (javaType.isIn('Integer', 'Float')) {
                                queryField.type = 'Num2';
                            }
                        }
                        //自动初始化上下文绑定
                        if (queryField.ctxBindName == null && this.forHisQry && this.givenCtxBindings != null) {
                            queryField.ctxBindName = this.givenCtxBindings[queryField.code] || null;
                        }
                        //
                        this.theVRowId.setId(queryField);
                        //
                        fieldConfRows.append(queryField);
                    }
                    //
                    this.init(fieldConfRows);
                }
            },
            appendFromCols() {
                let hisTblName = this.hisTblName;
                if (Utils.isNoB(hisTblName)) {
                    Toast.show('未指定库表，操作无法继续', 5000, 'warning');
                    return;
                }
                //
                let iniSelected = [];
                //当前存在的
                let fieldConfRows = this.gridForm.fieldConfRows;
                fieldConfRows.forEach(function (confRow) {
                    let code = (confRow.code || '').trim();
                    if (code) {
                        iniSelected.push(code);
                    }
                });
                //
                let self = this;
                showDbColSelectDlg({
                    tableName: hisTblName,
                    iniSelected: iniSelected
                }, function (selectedCols) {
                    console.log(selectedCols);
                    self.appendByCols(selectedCols);
                });
            },
            inputJsonConf() {
                let metaFields = this.getMetaQueryFields() || [];
                //
                let self = this;
                Vue.$showDialog({
                    title: '输入json配置 - meta queryFields',
                    width: 800,//80%
                    height: -100,//80%
                    showCloseBtn: false,
                    centerButtons: true,
                    template: '<swb-code-editor style="width:740px;height:100%;margin:0;" language="json" v-model="content" ></swb-code-editor>',
                    data: {content: JSON.format(metaFields)},

                    okClicked: function () {
                        let jsonModel = (this.content || '').trim();
                        console.debug(jsonModel);
                        let metaFields = [];
                        try {
                            metaFields = JSON.decode(jsonModel)
                        } catch (ex) {
                            //console.warn(ex);
                        }
                        if (metaFields.length < 1) {
                            this.$message({
                                type: 'warning',
                                message: 'json 数组模型无效'
                            });
                            return false;
                        }
                        //
                        self.resetMetaQueryFields(metaFields);
                    }
                });
            },
            handleSaveCustConf() {
                if (this.onSaveCustConf) {
                    this.onSaveCustConf();
                } else {
                    console.warn('未设置 onSaveCustConf 事件处理函数')
                }
            },
            handleConfirm() {
                if (this.onConfirm) {
                    this.onConfirm();
                } else {
                    console.warn('未设置 onConfirm 事件处理函数')
                }
            },
            //
            handleClose() {
                if (this.onClose) {
                    this.onClose();
                } else {
                    console.warn('未设置 onClose 事件处理函数')
                }
            },
            //===================================== 公开方法 =======================================
            //重置元列列表
            resetMetaQueryFields(metaQueryFields = []) {
                this.init(metaQueryFields);
            },
            //是否带着当前值保存个性调整
            getWidthCurValues() {
                return this.widthCurValues;
            },
            //获取自定义配置（仅包含自定义部分）
            getCustQueryFields(debugOnly) {
                let fieldConfRows = this.gridForm.fieldConfRows;
                //
                fieldConfRows = Utils.merge([], fieldConfRows);
                //过滤无效的
                fieldConfRows = fieldConfRows.filter(function (fieldConf) {
                    return isValidQueryField(fieldConf);
                });
                //
                return this.userMode == 2 || debugOnly ? fieldConfRows.map(function (item) {
                    return extractCustQueryFieldInfo(item);
                }) : [];
            },
            //获取定义的配置信息（全息）
            getMetaQueryFields() {
                let fieldConfRows = this.gridForm.fieldConfRows;
                //
                fieldConfRows = Utils.merge([], fieldConfRows);
                //过滤无效的
                fieldConfRows = fieldConfRows.filter(function (fieldConf) {
                    return isValidQueryField(fieldConf);
                });
                //数据调整
                let theVRowId = this.theVRowId;
                //
                fieldConfRows.forEach(function (item) {
                    theVRowId.delId(item);
                    //
                    delete item.validValueTypes;
                    delete item.placeholder;
                    let type = item.type;
                    //
                    if (type !== 'Text' || item.valueType !== 'String') {
                        delete item.useLikeMatch;
                    }
                    //dataList
                    if (type.isIn('Select', 'RadioGroup', 'Casc')) {
                        if (item.dataList == null) {
                            item.dataList = [];
                        }
                        if (typeof item.value != 'undefined') {//校验初始值
                            let tempValue = convertToTypedValue(item.value, item.valueType);
                            if (item.dataList > 1) {
                                let itemValues = item.dataList.map(function (elm) {
                                    return elm[item.dataValue || 'value'];
                                });
                                item.value = isStrMemberOf(tempValue, itemValues) ? tempValue : null;
                            } else {
                                item.value = tempValue;
                            }
                        }
                        if (type != 'Select') {
                            if (type != 'Casc') {
                                delete item.multiple;
                                delete item.collapseTags;
                                delete item.filterable;
                            }
                            delete item.firstOnClear;
                            delete item.multipleLimit;
                            delete item.firstIsMutex;
                        }
                    } else {
                        if (type == 'Checkbox') {
                            if (typeof item.value != 'undefined') {
                                item.value = convertToTypedValue(item.value, item.valueType);
                            }
                        } else {
                            delete item.value;
                        }
                        delete item.dataList;
                        delete item.multiple;
                        delete item.firstOnClear;
                        delete item.multipleLimit;
                        delete item.firstIsMutex;
                        delete item.collapseTags;
                        delete item.filterable;
                    }
                    //time
                    if (!type.isIn('Date', 'Date2') || item.valueType == 'Integer') {
                        delete item.time;
                    }
                    //defExpr
                    if (!type.isIn('Date', 'Month')) {
                        delete item.defExpr;
                    }
                    //defExpr_from , defExpr_to
                    if (!type.isIn('Date2', 'Month2')) {
                        delete item.defExpr_from;
                        delete item.defExpr_to;
                    }
                    if (typeof item.cascName == 'string') {
                        item.cascName = item.cascName.trim();
                        if (item.cascName == '') {
                            delete item.cascName;
                        }
                    } else {
                        delete item.cascName;
                    }
                    //
                    //动态标签字段
                    if (!item.dynaTag) {
                        delete item['tagMetaRole'];
                        delete item['tagMetaTableName'];
                    }
                });
                //
                return fieldConfRows;
            }
        }
    }
</script>

<style>
    .query-conf-form .el-table table tbody tr.filter-hidden {
        display: none;
    }

    .query-conf-form .el-table__body tr.basic-field > td {
        background-color: #FDF5E6 !important;
    }

    .query-conf-form .el-table__body tr.hidden-field > td,
    .query-conf-form .el-table__body tr.hidden-field > td input,
    .query-conf-form .el-table__body tr.hidden-field > td select,
    .query-conf-form .el-table__body tr.hidden-field > td button {
        font-style: italic;
        color: #AAAAAA !important;
    }

    .query-conf-form .el-table__body tr.invalid-code > td .field-code input {
        border: 1px dashed red;
    }

    .query-conf-form .el-table__body tr.invalid-label > td .field-label input {
        border: 1px dashed red;
    }

    .query-conf-form .el-table__body tr.invalid-type > td .field-type input {
        border: 1px dashed red;
    }

    .query-conf-form .el-table__body tr.invalid-valueType > td .field-valueType select {
        border: 1px dashed red;
    }

    .query-conf-form .el-table__body .cell select {
        border: 1px solid #DDD;
        border-radius: 2px;
        margin-top: 2px;
        font-size: 14px;
        padding: 0 2px 2px 2px;
        height: 28px;
        color: #666;
        width: 100%;
    }

    .query-conf-form .el-table__body .cell .el-button {
        margin-top: 3px;
    }
</style>




// WEBPACK FOOTER //
// src/compo/query/QueryFieldConf.vue